/* rbac-ui.jsx — small RBAC-07 presentation helpers for the aggregate (org / "all
   my teams") build views. The WorkspaceSwitcher + the nav gating live in
   sidebar.jsx (RBAC-07); this file is just the per-row workspace ATTRIBUTION
   (GAP-5) the org/lead lists need: which workspace a build belongs to.

   Data source = the tags loadContextBuilds (hydrate.js) stamps onto each row:
     • org rows  → _wsSlug (the /api/org/builds workspace_slug; thin projection)
     • lead 'all' rows → _wsName + _wsSlug (from the fanned-out membership)
   Single-tenant rows carry neither (attribution is implicit) → no tag rendered. */

// stable per-workspace hue from the slug, so each workspace reads distinctly
function wsColor(slug) {
  if (!slug) return 'var(--faint)';
  let h = 0;
  for (let i = 0; i < slug.length; i++) h = (h * 31 + slug.charCodeAt(i)) % 360;
  return 'hsl(' + h + ' 55% 50%)';
}

function WsDot({ color, size = 8 }) {
  return <span style={{ width: size, height: size, borderRadius: size / 2, background: color || 'var(--brand-amber, #C8973F)', display: 'inline-block', flexShrink: 0 }} />;
}

const _WS_TAG = { display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12, fontWeight: 600, color: 'var(--ink-2)', whiteSpace: 'nowrap' };

function WorkspaceTag({ job, size = 8 }) {
  const label = job && (job._wsName || job._wsSlug);
  if (!label) return <span className="ws-tag" style={{ ..._WS_TAG, color: 'var(--faint)', fontWeight: 500 }}><WsDot color="var(--faint)" size={size} />Unassigned</span>;
  return <span className="ws-tag" style={_WS_TAG}><WsDot color={wsColor(job._wsSlug || label)} size={size} />{label}</span>;
}

Object.assign(window, { WorkspaceTag, WsDot, wsWorkspaceColor: wsColor });
